<template>
  <div>
    <!-- <span>我是师资队伍</span> -->
    <router-view />
  </div>
</template>


